import { contains, makeFilter, mergeFilters } from '@/utils/dynamic'

export default {
  mode: {
    isModalNew: true,
    isModalPush: true
  },
  store: {
    get: {
      url: 'Panels/GetAllPanelFleet',
      selected: ['id', 'employeeName', 'companyName', 'companyTypeTitle', 'regionTitle', 'aircraftModel', 'scoreTitle'].join(',')
    }
  },
  header: {
    controls: {
      isVisible: true,
      export: {
        json: {
          current: {
            isVisible: false
          },
          all: {
            isVisible: false
          }
        }
      },
      addNew: {
        isVisible: false
      }
    }
  },
  columns: [
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: '${root.L10n("employee")}',
      field: 'employeeName'
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: '${root.L10n("customer")}',
      field: 'companyName'
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: '${root.L10n("company-type")}',
      field: 'companyTypeTitle'
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: '${root.L10n("region")}',
      field: 'regionTitle'
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: '${root.L10n("aircraft-model")}',
      field: 'aircraftModel'
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: '${root.L10n("score")}',
      field: 'scoreTitle'
    }
  ],
  toolbar: {
    filters: [
      {
        type: 'string',
        field: 'title',
        options: {
          valueTemplate: (data) => mergeFilters(
            makeFilter(['employeeName', 'companyName', 'companyTypeTitle', 'regionTitle', 'aircraftModel', 'scoreTitle'], data.dataValue, contains)
          ).join('&&'),
          // eslint-disable-next-line no-template-curly-in-string
          placeholder: '${root.L10n("search")}',
          styles: {
            minWidth: '15rem'
          }
        }
      },
      {
        type: 'select',
        field: 'employeeID',
        // eslint-disable-next-line no-template-curly-in-string
        label: "${root.L10n('employee')}",
        options: {
          dataSource: 'Employees/GetAllDynamic?select=id,name as title&filter=isActive==true',
          // eslint-disable-next-line no-template-curly-in-string
          placeholder: "${root.L10n('all')}"
        }
      },
      {
        type: 'select',
        field: 'regionID',
        // eslint-disable-next-line no-template-curly-in-string
        label: "${root.L10n('region')}",
        options: {
          dataSource: 'Regions/GetAllDynamic?select=id,title',
          // eslint-disable-next-line no-template-curly-in-string
          placeholder: "${root.L10n('all')}"
        }
      },
      {
        type: 'select',
        field: 'aircraftID',
        // eslint-disable-next-line no-template-curly-in-string
        label: "${root.L10n('aircraft-model')}",
        options: {
          dataSource: 'Aircrafts/GetAllDynamic?select=id,aircraftModel as title',
          // eslint-disable-next-line no-template-curly-in-string
          placeholder: "${root.L10n('all')}",
          styles: {
            minWidth: '20rem'
          }
        }
      },
      {
        type: 'select',
        field: 'companyTypeID',
        // eslint-disable-next-line no-template-curly-in-string
        label: "${root.L10n('company-type')}",
        options: {
          dataSource: 'CompanyTypes/GetAllDynamic?select=id,title',
          // eslint-disable-next-line no-template-curly-in-string
          placeholder: "${root.L10n('all')}",
          styles: {
            minWidth: '18rem'
          }
        }
      }
    ]
  },
  rowControls: {
    right: {
      controls: []
    }
  },
  pagination: {
    size: 100,
    sizes: {
      isVisible: true,
      values: [
        {
          label: '10',
          value: 10
        },
        {
          label: '15',
          value: 15
        },
        {
          label: '25',
          value: 25
        },
        {
          label: '50',
          value: 50
        },
        {
          label: '100',
          value: 100
        },
        {
          label: '200',
          value: 200
        }
      ]
    }
  }
}
